import { useTranslation } from "react-i18next"

import { useLocale } from "@/shared/hooks/useLocale"
import type { LocaleCode } from "@/shared/i18n"

export interface LangSelectProps {
  className?: string
}

/**
 * 官网语言选择器：简体中文 / English / ខ្មែរ。
 * 选项名用各自语言的自称（endonym），因此三语下保持一致。
 * 可选项来自当前页面声明的语言范围（createPage 的 locales）。
 */
export function LangSelect({ className }: LangSelectProps) {
  const { t } = useTranslation()
  const { locale, locales, setLocale } = useLocale()

  const options = [
    { code: "zh_CN" as LocaleCode, label: t("official_lang_option_zh") },
    { code: "en_US" as LocaleCode, label: t("official_lang_option_en") },
    { code: "km_KH" as LocaleCode, label: t("official_lang_option_km") },
  ].filter((option) => locales.includes(option.code))

  return (
    <label className={`inline-flex items-center ${className ?? ""}`}>
      <span className="sr-only">{t("official_lang_label")}</span>
      <select
        value={locale}
        onChange={(event) => setLocale(event.target.value as LocaleCode)}
        aria-label={t("official_lang_label")}
        className="h-9 cursor-pointer rounded-full border border-line bg-white px-3 pr-7 text-[13px] font-medium text-ink-secondary outline-none focus:border-primary"
      >
        {options.map((option) => (
          <option key={option.code} value={option.code}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  )
}
